import { InjectionToken } from '@angular/core';
import { FormFieldConfigs } from '../models/form-field-configs.model';

export const FORM_FIELD_CONFIGS = new InjectionToken<FormFieldConfigs>(
  'FORM_FIELD_CONFIGS'
);
